(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-daydream-hero"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-daydream-hero')) {
		class LTADaydreamHero extends HTMLElement {
			constructor() {
				super()
				this._onTriggerClick = this._onTriggerClick.bind(this)
				this._onDialogClick = this._onDialogClick.bind(this)
				this._onDialogClose = this._onDialogClose.bind(this)
				this._cleanups = []
			}

			connectedCallback() {
				this.dialogEl = this.querySelector('[data-video-dialog]')
				this.frameEl = this.querySelector('[data-video-frame]')
				this.triggerEls = this.querySelectorAll('[data-video-trigger]')

				this.triggerEls.forEach((el) => {
					el.addEventListener('click', this._onTriggerClick)
					this._cleanups.push(() => el.removeEventListener('click', this._onTriggerClick))
				})

				if (this.dialogEl) {
					this.dialogEl.addEventListener('click', this._onDialogClick)
					this.dialogEl.addEventListener('close', this._onDialogClose)
					this._cleanups.push(() => this.dialogEl.removeEventListener('click', this._onDialogClick))
					this._cleanups.push(() => this.dialogEl.removeEventListener('close', this._onDialogClose))
				}
			}

			disconnectedCallback() {
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
				this._clearVideo()
			}

			_onTriggerClick(event) {
				const trigger = event.currentTarget
				const type = trigger.getAttribute('data-video-type')
				const id = trigger.getAttribute('data-video-id')
				if (!type || !id || !this.dialogEl || !this.frameEl) return

				this._mountVideo(type, id)
				if (typeof this.dialogEl.showModal === 'function') {
					this.dialogEl.showModal()
				} else {
					this.dialogEl.setAttribute('open', '')
				}
			}

			/* Backdrop click (showModal): target === dialog */
			_onDialogClick(event) {
				if (event.target !== this.dialogEl) return
				this.dialogEl.close()
			}

			_onDialogClose() {
				this._clearVideo()
			}

			_mountVideo(type, id) {
				this._clearVideo()

				const iframe = document.createElement('iframe')
				iframe.title = 'Daydream story video'
				iframe.allowFullscreen = true

				if (type === 'youtube') {
					iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`
					iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
				} else {
					iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1`
					iframe.allow = 'autoplay; fullscreen; picture-in-picture'
				}

				this.frameEl.appendChild(iframe)
			}

			_clearVideo() {
				if (!this.frameEl) return
				this.frameEl.replaceChildren()
			}
		}

		customElements.define('l-daydream-hero', LTADaydreamHero)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-daydream-pdp"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-daydream-pdp-form')) {
		class LTADaydreamPdpForm extends HTMLElement {
			connectedCallback() {
				this.buttonEl = this.querySelector('[data-atc]')
				this.qtyInputEl = this.querySelector('[data-qty-input]')
				this.qtyMinusEl = this.querySelector('[data-qty-minus]')
				this.qtyPlusEl = this.querySelector('[data-qty-plus]')

				this._onClick = this._onClick.bind(this)
				this._onCartSettled = this._onCartSettled.bind(this)
				this._onQtyMinus = this._onQtyMinus.bind(this)
				this._onQtyPlus = this._onQtyPlus.bind(this)
				this._onQtyInput = this._onQtyInput.bind(this)

				if (this.buttonEl) {
					this.buttonEl.addEventListener('click', this._onClick)
					document.addEventListener('theme:cart:added', this._onCartSettled)
					document.addEventListener('theme:cart:add:success', this._onCartSettled)
				}

				if (this.qtyMinusEl) this.qtyMinusEl.addEventListener('click', this._onQtyMinus)
				if (this.qtyPlusEl) this.qtyPlusEl.addEventListener('click', this._onQtyPlus)
				if (this.qtyInputEl) this.qtyInputEl.addEventListener('change', this._onQtyInput)

				this._syncQtyControls()
			}

			disconnectedCallback() {
				if (this.buttonEl) {
					this.buttonEl.removeEventListener('click', this._onClick)
					document.removeEventListener('theme:cart:added', this._onCartSettled)
					document.removeEventListener('theme:cart:add:success', this._onCartSettled)
				}

				if (this.qtyMinusEl) this.qtyMinusEl.removeEventListener('click', this._onQtyMinus)
				if (this.qtyPlusEl) this.qtyPlusEl.removeEventListener('click', this._onQtyPlus)
				if (this.qtyInputEl) this.qtyInputEl.removeEventListener('change', this._onQtyInput)

				this._clearLoadingTimeout()
			}

			_getQty() {
				if (!this.qtyInputEl) return 1
				const value = Number.parseInt(this.qtyInputEl.value, 10)
				return Number.isFinite(value) ? value : 1
			}

			_setQty(value) {
				if (!this.qtyInputEl) return
				const min = Number.parseInt(this.qtyInputEl.min || '1', 10) || 1
				const next = Math.max(min, value)
				this.qtyInputEl.value = String(next)
				this._syncQtyControls()
			}

			_syncQtyControls() {
				if (!this.qtyInputEl || !this.qtyMinusEl) return
				const min = Number.parseInt(this.qtyInputEl.min || '1', 10) || 1
				this.qtyMinusEl.disabled = this._getQty() <= min
			}

			_onQtyMinus() {
				this._setQty(this._getQty() - 1)
			}

			_onQtyPlus() {
				this._setQty(this._getQty() + 1)
			}

			_onQtyInput() {
				this._setQty(this._getQty())
			}

			_onClick() {
				if (!this.buttonEl || this.buttonEl.disabled || this.buttonEl.classList.contains('is-loading')) return

				this.buttonEl.classList.add('is-loading')
				this.buttonEl.setAttribute('aria-busy', 'true')

				this._clearLoadingTimeout()
				this._loadingTimeout = setTimeout(() => this._onCartSettled(), 8000)
			}

			_onCartSettled() {
				if (!this.buttonEl) return

				this.buttonEl.classList.remove('is-loading')
				this.buttonEl.removeAttribute('aria-busy')
				this._clearLoadingTimeout()
			}

			_clearLoadingTimeout() {
				if (!this._loadingTimeout) return
				clearTimeout(this._loadingTimeout)
				this._loadingTimeout = null
			}
		}

		customElements.define('l-daydream-pdp-form', LTADaydreamPdpForm)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-daydream-product"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-daydream-product-form')) {
		class LTADaydreamProductForm extends HTMLElement {
			connectedCallback() {
				this.buttonEl = this.querySelector('[data-atc]')
				if (!this.buttonEl) return

				this._onClick = this._onClick.bind(this)
				this._onCartSettled = this._onCartSettled.bind(this)

				this.buttonEl.addEventListener('click', this._onClick)
				document.addEventListener('theme:cart:added', this._onCartSettled)
				document.addEventListener('theme:cart:add:success', this._onCartSettled)
			}

			disconnectedCallback() {
				if (!this.buttonEl) return

				this.buttonEl.removeEventListener('click', this._onClick)
				document.removeEventListener('theme:cart:added', this._onCartSettled)
				document.removeEventListener('theme:cart:add:success', this._onCartSettled)
				this._clearLoadingTimeout()
			}

			_onClick() {
				if (this.buttonEl.disabled || this.buttonEl.classList.contains('is-loading')) return

				this.buttonEl.classList.add('is-loading')
				this.buttonEl.setAttribute('aria-busy', 'true')

				this._clearLoadingTimeout()
				this._loadingTimeout = setTimeout(() => this._onCartSettled(), 8000)
			}

			_onCartSettled() {
				if (!this.buttonEl) return

				this.buttonEl.classList.remove('is-loading')
				this.buttonEl.removeAttribute('aria-busy')
				this._clearLoadingTimeout()
			}

			_clearLoadingTimeout() {
				if (!this._loadingTimeout) return
				clearTimeout(this._loadingTimeout)
				this._loadingTimeout = null
			}
		}

		customElements.define('l-daydream-product-form', LTADaydreamProductForm)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-daydream-spanning-bg"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-daydream-spanning-bg')) {
		class LTADaydreamSpanningBg extends HTMLElement {
			constructor() {
				super()
				this._onUpdate = this._onUpdate.bind(this)
				this._onEditorEvent = this._onEditorEvent.bind(this)
				this._cleanups = []
				this._raf = null
				this._observer = null
				this._observedEls = new Set()
			}

			connectedCallback() {
				window.addEventListener('resize', this._onUpdate, { passive: true })
				window.addEventListener('orientationchange', this._onUpdate, { passive: true })
				window.addEventListener('load', this._onUpdate, { passive: true })
				this._cleanups.push(() => window.removeEventListener('resize', this._onUpdate))
				this._cleanups.push(() => window.removeEventListener('orientationchange', this._onUpdate))
				this._cleanups.push(() => window.removeEventListener('load', this._onUpdate))

				if (window.visualViewport) {
					window.visualViewport.addEventListener('resize', this._onUpdate, { passive: true })
					this._cleanups.push(() => window.visualViewport.removeEventListener('resize', this._onUpdate))
				}

				document.addEventListener('shopify:section:load', this._onEditorEvent)
				document.addEventListener('shopify:section:reorder', this._onEditorEvent)
				document.addEventListener('shopify:section:unload', this._onEditorEvent)
				this._cleanups.push(() => document.removeEventListener('shopify:section:load', this._onEditorEvent))
				this._cleanups.push(() => document.removeEventListener('shopify:section:reorder', this._onEditorEvent))
				this._cleanups.push(() => document.removeEventListener('shopify:section:unload', this._onEditorEvent))

				if (typeof ResizeObserver !== 'undefined') {
					this._observer = new ResizeObserver(this._onUpdate)
					this._observer.observe(document.documentElement)
					this._cleanups.push(() => {
						this._observer?.disconnect()
						this._observer = null
						this._observedEls.clear()
					})
				}

				const img = this.querySelector('img')
				if (img && !img.complete) {
					img.addEventListener('load', this._onUpdate, { once: true })
				}

				this._onUpdate()
			}

			disconnectedCallback() {
				if (this._raf) cancelAnimationFrame(this._raf)
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
			}

			_onEditorEvent() {
				this._onUpdate()
			}

			_onUpdate() {
				if (this._raf) cancelAnimationFrame(this._raf)
				/* Double rAF so layout settles after viewport / breakpoint changes */
				this._raf = requestAnimationFrame(() => {
					this._raf = requestAnimationFrame(() => this._updatePosition())
				})
			}

			_resolveEl(id) {
				if (!id) return null
				const clean = String(id).trim().replace(/^#/, '')
				if (!clean) return null
				return document.getElementById(clean)
			}

			_getSectionEl(el) {
				return el?.closest('[id^="shopify-section-"]') || el
			}

			_observeEl(el) {
				if (!el || !this._observer || this._observedEls.has(el)) return
				this._observer.observe(el)
				this._observedEls.add(el)
			}

			_updatePosition() {
				const topEl = this._resolveEl(this.dataset.topSection)
				const bottomEl = this._resolveEl(this.dataset.bottomSection)
				if (!topEl || !bottomEl) return

				const topSection = this._getSectionEl(topEl)
				const bottomSection = this._getSectionEl(bottomEl)

				this._observeEl(topSection)
				this._observeEl(bottomSection)

				const hostSection = this.closest('[id^="shopify-section-"]') || this
				const scrollY = window.scrollY || window.pageYOffset
				const hostTop = hostSection.getBoundingClientRect().top + scrollY

				/* Use shopify-section box so padding-block (l-section) is included */
				const spanTop = topSection.getBoundingClientRect().top + scrollY
				const spanBottom = bottomSection.getBoundingClientRect().bottom + scrollY
				const height = Math.max(0, spanBottom - spanTop)

				this.style.setProperty('--l-sDDSpanBg-inset-block-start', `${spanTop - hostTop}px`)
				this.style.setProperty('--l-sDDSpanBg-block-size', `${height}px`)
			}
		}

		customElements.define('l-daydream-spanning-bg', LTADaydreamSpanningBg)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-hp-collection-tabs"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-hp-collection-tabs')) {
		class LTAHPCollectionTabs extends HTMLElement {
			constructor() {
				super()

				this.handleTabClick = this.handleTabClick.bind(this)
			}

			connectedCallback() {
				this.tabEls = this.querySelectorAll('[data-tab-button]')
				this.productTabsEls = this.querySelectorAll('[data-products]')

				this.tabEls.forEach((tabEl) => {
					tabEl.addEventListener('click', this.handleTabClick)
				})
			}

			disconnectedCallback() {
				if (this.tabEls) {
					this.tabEls.forEach((tabEl) => {
						tabEl.removeEventListener('click', this.handleTabClick)
					})
				}
			}

			handleTabClick(event) {
				const tabEl = event.currentTarget
				if (!tabEl) return
				const blockId = tabEl.getAttribute('data-tab-button')

				this.toggleProductTabs(blockId)
			}

			toggleProductTabs(blockId) {
				if (!blockId) return

				this.tabEls.forEach((tabEl) => {
					const isActive = tabEl.getAttribute('data-tab-button') === blockId
					tabEl.classList.toggle('is-active', isActive)
				})

				this.productTabsEls.forEach((productTabEl) => {
					const productBlockId = productTabEl.getAttribute('data-products')
					productTabEl.classList.toggle('l-hidden', productBlockId !== blockId)
				})
			}
		}

		customElements.define('l-hp-collection-tabs', LTAHPCollectionTabs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-main-collection"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-plp')) {
		class LTAPlp extends HTMLElement {
			constructor() {
				super()

				this.onIntersect = this.onIntersect.bind(this)
				this.onLoadMoreClick = this.onLoadMoreClick.bind(this)
				this.onSortChange = this.onSortChange.bind(this)
				this.abortController = null
			}

			connectedCallback() {
				this.reinitialize()
				this.applyDefaultSortIfNeeded()
			}

			disconnectedCallback() {
				this.abortController?.abort()
				this.observer?.disconnect()
			}

			reinitialize() {
				this.abortController?.abort()
				this.abortController = new AbortController()
				this.observer?.disconnect()

				const { signal } = this.abortController

				this.sectionId = this.dataset.sectionId
				this.loadingType = this.dataset.loadingType || 'pagination'
				this.isLoading = false
				this.loadedUrls = new Set()
				this.nextPageUrl = ''

				this.gridEl = this.querySelector('[data-plp-grid]')
				this.sentinelEl = this.querySelector('[data-plp-sentinel]')
				this.loadMoreEl = this.querySelector('[data-plp-load-more]')
				this.loadMoreBtn = this.querySelector('[data-plp-load-more-button]')
				this.loaderEl = this.querySelector('[data-plp-loader]')
				this.sortSelect = this.querySelector('[data-plp-sort]')

				const configEl = this.querySelector('[data-plp-config]')
				if (configEl) {
					try {
						const config = JSON.parse(configEl.textContent)
						this.nextPageUrl = config.nextUrl || ''
					} catch {
						this.nextPageUrl = ''
					}
				}

				this.sortSelect?.addEventListener('change', this.onSortChange, { signal })

				if (!this.gridEl || this.loadingType === 'pagination') {
					return
				}

				if (this.loadingType === 'infinite_scroll' && this.sentinelEl && this.nextPageUrl) {
					const preloadOffset = Math.round(window.innerHeight)

					this.observer = new IntersectionObserver(this.onIntersect, {
						rootMargin: `0px 0px ${preloadOffset}px 0px`,
					})
					this.observeSentinel()
					return
				}

				if (this.loadingType === 'load_more' && this.loadMoreBtn && this.nextPageUrl) {
					this.loadMoreBtn.addEventListener('click', this.onLoadMoreClick, { signal })
				}
			}

			observeSentinel() {
				if (this.observer && this.sentinelEl) {
					this.observer.observe(this.sentinelEl)
				}
			}

			unobserveSentinel() {
				if (this.observer && this.sentinelEl) {
					this.observer.unobserve(this.sentinelEl)
				}
			}

			getExistingProductIds() {
				return new Set(
					[...this.gridEl.querySelectorAll('[data-plp-item]')].map((item) => item.dataset.productId).filter(Boolean)
				)
			}

			getSectionRoot(template) {
				return (
					template.content.getElementById(`shopify-section-${this.sectionId}`) ||
					template.content.querySelector('[data-plp-grid]')?.closest('.shopify-section') ||
					template.content
				)
			}

			onIntersect(entries) {
				if (entries.some((entry) => entry.isIntersecting)) {
					this.loadMore()
				}
			}

			onLoadMoreClick() {
				this.loadMore()
			}

			onSortChange(event) {
				this.applySort(event.target.value)
			}

			resetSortSelect() {
				if (this.sortSelect) {
					this.sortSelect.value = this.dataset.sortBy
				}
			}

			getSortFetchUrl(sortValue) {
				const collectionUrl = this.dataset.collectionUrl
				if (!collectionUrl) return null

				const collectionPath = new URL(collectionUrl, window.location.origin).pathname
				const isOnCollectionPage =
					window.location.pathname === collectionPath || window.location.pathname.endsWith(collectionPath)

				const url = isOnCollectionPage
					? new URL(window.location.href)
					: new URL(collectionUrl, window.location.origin)

				url.searchParams.set('sort_by', sortValue)
				url.searchParams.delete('page')
				url.searchParams.set('section_id', this.sectionId)

				return url
			}

			updateBrowserUrl(sortValue) {
				const collectionUrl = this.dataset.collectionUrl
				if (!collectionUrl) return

				const collectionPath = new URL(collectionUrl, window.location.origin).pathname
				const isOnCollectionPage =
					window.location.pathname === collectionPath || window.location.pathname.endsWith(collectionPath)

				if (!isOnCollectionPage) return

				const url = new URL(window.location.href)
				url.searchParams.set('sort_by', sortValue)
				url.searchParams.delete('page')
				history.replaceState({}, '', url.toString())
			}

			applyDefaultSortIfNeeded() {
				if (this.dataset.defaultSortApplied === 'true') return

				const url = new URL(window.location.href)
				if (url.searchParams.has('sort_by')) return

				this.dataset.defaultSortApplied = 'true'
				this.applySort(this.dataset.defaultSort || 'best-selling', { force: true })
			}

			async applySort(sortValue, options = {}) {
				const collectionUrl = this.dataset.collectionUrl
				const fetchUrl = this.getSortFetchUrl(sortValue)

				if (this.isLoading || !sortValue || !collectionUrl || !fetchUrl) {
					return
				}

				if (!options.force && sortValue === this.dataset.sortBy) {
					return
				}

				this.isLoading = true
				this.classList.add('is-sorting')

				try {
					const response = await fetch(fetchUrl.toString())
					if (!response.ok) {
						this.resetSortSelect()
						return
					}

					const html = await response.text()
					const template = document.createElement('template')
					template.innerHTML = html.trim()

					const sectionRoot = this.getSectionRoot(template)
					const newPlp = sectionRoot.querySelector('l-plp')
					if (!newPlp) {
						this.resetSortSelect()
						return
					}

					this.dataset.sortBy = sortValue
					this.updateBrowserUrl(sortValue)
					this.innerHTML = newPlp.innerHTML
					this.loadedUrls = new Set()
					this.reinitialize()
					this.initOkendoWidgets()
				} finally {
					this.isLoading = false
					this.classList.remove('is-sorting')
				}
			}

			setLoadingState(isLoading) {
				this.isLoading = isLoading
				this.classList.toggle('is-loading', isLoading)

				if (this.loaderEl) {
					this.loaderEl.setAttribute('aria-busy', isLoading ? 'true' : 'false')
					this.loaderEl.setAttribute('aria-hidden', isLoading ? 'false' : 'true')
				}

				if (this.loadMoreBtn) {
					this.loadMoreBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false')
				}
			}

			initOkendoWidgets() {
				window.okeWidgetApi?.initAllWidgets?.()
			}

			async loadMore() {
				if (this.isLoading || !this.nextPageUrl) return

				const fetchUrl = this.nextPageUrl
				if (this.loadedUrls.has(fetchUrl)) {
					this.nextPageUrl = ''
					this.removeLoadingUi()
					return
				}

				this.isLoading = true

				if (this.loadingType === 'infinite_scroll') {
					this.unobserveSentinel()
				}

				this.setLoadingState(true)

				try {
					const url = new URL(fetchUrl, window.location.origin)
					url.searchParams.set('section_id', this.sectionId)

					const response = await fetch(url.toString())
					if (!response.ok) return

					const html = await response.text()
					const template = document.createElement('template')
					template.innerHTML = html.trim()

					const sectionRoot = this.getSectionRoot(template)
					const fetchedGrid = sectionRoot.querySelector('[data-plp-grid]')
					if (!fetchedGrid) return

					const existingProductIds = this.getExistingProductIds()
					const items = [...fetchedGrid.querySelectorAll('[data-plp-item]')].filter(
						(item) => !existingProductIds.has(item.dataset.productId)
					)

					items.forEach((item) => this.gridEl.appendChild(item))

					if (items.length > 0) {
						this.initOkendoWidgets()
					}

					this.loadedUrls.add(fetchUrl)

					const nextLink = sectionRoot.querySelector('[data-plp-next-url]')
					const nextPageUrl = nextLink?.getAttribute('href') || ''

					if (nextPageUrl && nextPageUrl !== fetchUrl && !this.loadedUrls.has(nextPageUrl)) {
						this.nextPageUrl = nextPageUrl

						const configEl = this.querySelector('[data-plp-config]')
						if (configEl) {
							configEl.textContent = JSON.stringify({ nextUrl: this.nextPageUrl })
						}

						const currentNextLink = this.querySelector('[data-plp-next-url]')
						if (currentNextLink) {
							currentNextLink.setAttribute('href', this.nextPageUrl)
						}
					} else {
						this.nextPageUrl = ''
						this.removeLoadingUi()
					}
				} finally {
					this.isLoading = false
					this.setLoadingState(false)

					if (this.nextPageUrl && this.loadingType === 'infinite_scroll' && this.sentinelEl?.isConnected) {
						this.observeSentinel()
					}
				}
			}

			removeLoadingUi() {
				if (this.loadingType === 'infinite_scroll') {
					this.unobserveSentinel()
					this.sentinelEl?.remove()
					return
				}

				if (this.loadingType === 'load_more') {
					this.loadMoreEl?.remove()
				}
			}
		}

		customElements.define('l-plp', LTAPlp)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-stix-sticky-bar"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-stix-sticky-bar')) {
		class LStixStickyBar extends HTMLElement {
			constructor() {
				super()
				this.handleScroll = this.handleScroll.bind(this)
			}

			connectedCallback() {
				this.handleScroll()
				window.addEventListener('scroll', this.handleScroll, { passive: true })
			}

			disconnectedCallback() {
				window.removeEventListener('scroll', this.handleScroll)
			}

			handleScroll() {
				const shouldShow = window.scrollY > 300
				this.parentElement.classList.toggle('is-visible', shouldShow)
			}
		}

		customElements.define('l-stix-sticky-bar', LStixStickyBar)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-top-seller-products"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-top-seller-products')) {
		class LTATopSellerProducts extends HTMLElement {
			constructor() {
				super()

				this.handleTabClick = this.handleTabClick.bind(this)
			}

			connectedCallback() {
				this.tabEls = this.querySelectorAll('[data-tab-button]')
				this.productTabsEls = this.querySelectorAll('[data-products]')

				this.tabEls.forEach((tabEl) => {
					tabEl.addEventListener('click', this.handleTabClick)
				})
			}

			disconnectedCallback() {
				if (this.tabEls) {
					this.tabEls.forEach((tabEl) => {
						tabEl.removeEventListener('click', this.handleTabClick)
					})
				}
			}

			handleTabClick(event) {
				const tabEl = event.currentTarget
				if (!tabEl) return

				const blockId = tabEl.getAttribute('data-tab-button')
				this.toggleProductTabs(blockId)
			}

			toggleProductTabs(blockId) {
				if (!blockId) return

				const nextPanel = Array.from(this.productTabsEls).find(
					(panelEl) => panelEl.getAttribute('data-products') === blockId
				)
				const currentPanel = Array.from(this.productTabsEls).find((panelEl) => panelEl.classList.contains('is-active'))

				if (!nextPanel || nextPanel === currentPanel) return

				this.tabEls.forEach((tabEl) => {
					const isActive = tabEl.getAttribute('data-tab-button') === blockId
					tabEl.classList.toggle('is-active', isActive)
				})

				const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

				if (prefersReducedMotion || !currentPanel) {
					if (currentPanel) {
						currentPanel.classList.remove('is-active', 'is-entering', 'is-leaving')
					}

					nextPanel.classList.remove('is-entering', 'is-leaving')
					nextPanel.classList.add('is-active')
					this.updatePanelSwiper(nextPanel)
					return
				}

				const onLeave = (event) => {
					if (event.target !== currentPanel || event.propertyName !== 'transform') return

					currentPanel.removeEventListener('transitionend', onLeave)
					currentPanel.classList.remove('is-leaving')

					nextPanel.classList.add('is-active', 'is-entering')

					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							nextPanel.classList.remove('is-entering')
							this.updatePanelSwiper(nextPanel)
						})
					})
				}

				currentPanel.classList.add('is-leaving')
				currentPanel.classList.remove('is-active')
				currentPanel.addEventListener('transitionend', onLeave)
			}

			updatePanelSwiper(panelEl) {
				const swiperEl = panelEl?.querySelector('l-swiper-carousel')
				if (!swiperEl?.swiperCarousel) return

				swiperEl.swiperCarousel.update()

				if (typeof swiperEl.setupNavigation === 'function') {
					swiperEl.setupNavigation()
				}
			}
		}

		customElements.define('l-top-seller-products', LTATopSellerProducts)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harvest"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHarvest(root) {
      if (root.dataset.harvestInit === '1') return;
      root.dataset.harvestInit = '1';

      var STORAGE_KEY = 'harvest_unlocked';

      // ----- access code gate -----
      var raw = (root.dataset.codes || '').toLowerCase();
      var validCodes = raw.split(',').map(function (c) { return c.trim(); }).filter(Boolean);

      function unlock() {
        root.classList.add('harvest--unlocked');
        // Don't persist inside the theme editor, so Stage 1 stays the default when editing.
        if (root.dataset.designMode !== 'true') {
          try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
        }
        window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
      }

      root.querySelectorAll('[data-harvest-code-form]').forEach(function (form) {
        var input = form.querySelector('.harvest__input');
        var error = form.querySelector('.harvest__code-error');
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var val = (input.value || '').trim().toLowerCase();
          var ok = validCodes.length ? validCodes.indexOf(val) !== -1 : val.length > 0;
          if (ok) {
            unlock();
          } else if (error) {
            error.classList.add('is-visible');
          }
        });
      });

      // ----- Klaviyo email signup -----
      var kcfg = {};
      var kcfgEl = root.querySelector('[data-harvest-klaviyo-config]');
      if (kcfgEl) { try { kcfg = JSON.parse(kcfgEl.textContent); } catch (e) {} }

      function parseProps(raw) {
        var props = {};
        (raw || '').split('\n').forEach(function (line) {
          var idx = line.indexOf(':');
          if (idx > 0) {
            var k = line.slice(0, idx).trim();
            var v = line.slice(idx + 1).trim();
            if (k) { props[k] = v; }
          }
        });
        return props;
      }

      root.querySelectorAll('[data-harvest-klaviyo]').forEach(function (form) {
        var input = form.querySelector('.harvest__input');
        var msg = form.querySelector('.harvest__form-msg');
        var btn = form.querySelector('button');

        function setMsg(text, kind) {
          if (!msg) return;
          msg.textContent = text || '';
          msg.className = 'harvest__form-msg' + (kind ? ' is-' + kind : '');
        }

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = (input.value || '').trim();
          if (!email) { return; }

          if (!kcfg.publicKey || !kcfg.listId) {
            setMsg(kcfg.errorText || 'Signup is not configured yet.', 'error');
            return;
          }

          var props = parseProps(kcfg.extraPropertiesRaw);
          props.signup_source = kcfg.customSource || 'Harvest Landing';
          props.harvest_stage = form.getAttribute('data-harvest-klaviyo') || 'stage_1';
          props.page_url = window.location.href;
          if (kcfg.campaign) { props.campaign = kcfg.campaign; }

          var payload = {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: kcfg.customSource || 'Harvest Landing',
                profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
              },
              relationships: { list: { data: { type: 'list', id: kcfg.listId } } }
            }
          };

          if (btn) { btn.disabled = true; }
          setMsg('', null);

          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(kcfg.publicKey), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': kcfg.revision || '2025-07-15' },
            body: JSON.stringify(payload)
          }).then(function (res) {
            if (res.ok || res.status === 202) {
              setMsg(kcfg.successText || 'You’re on the list.', 'success');
              form.reset();
            } else {
              return res.text().then(function (t) { throw new Error(t); });
            }
          }).catch(function () {
            setMsg(kcfg.errorText || 'Something went wrong. Please try again.', 'error');
          }).finally(function () {
            if (btn) { btn.disabled = false; }
          });
        });
      });

      // ----- countdown -----
      var timer = root.querySelector('[data-harvest-timer]');
      var targetStr = root.dataset.countdown;
      if (timer && targetStr) {
        var target = new Date(targetStr.replace(/-/g, '/')).getTime();
        var elDays = timer.querySelector('[data-days]');
        var elHours = timer.querySelector('[data-hours]');
        var elMins = timer.querySelector('[data-mins]');
        var elSecs = timer.querySelector('[data-secs]');
        var pad = function (n) { return String(Math.max(0, n)).padStart(2, '0'); };
        var tick = function () {
          var diff = target - Date.now();
          if (isNaN(target)) return;
          if (diff <= 0) {
            elDays.textContent = '00'; elHours.textContent = '00';
            elMins.textContent = '00'; elSecs.textContent = '00';
            clearInterval(iv);
            return;
          }
          var s = Math.floor(diff / 1000);
          elDays.textContent = pad(Math.floor(s / 86400));
          elHours.textContent = pad(Math.floor((s % 86400) / 3600));
          elMins.textContent = pad(Math.floor((s % 3600) / 60));
          elSecs.textContent = pad(s % 60);
        };
        tick();
        var iv = setInterval(tick, 1000);
      }

      // ----- alert ticker: seamless marquee -----
      var ticker = root.querySelector('[data-harvest-ticker]');
      var track = ticker ? ticker.querySelector('.harvest__ticker-track') : null;
      if (track && track.children.length) {
        var cloneItem = function (node) {
          var c = node.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          // Strip editor identifiers so duplicated ticker items don't confuse the theme-editor inspector.
          ['data-shopify-editor-block', 'data-shopify-editor-blocks', 'id'].forEach(function (a) { c.removeAttribute(a); });
          return c;
        };
        var setupTicker = function () {
          if (!track.dataset.tickerBase) {
            track.dataset.tickerBase = track.innerHTML;
          } else {
            track.innerHTML = track.dataset.tickerBase;
          }
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            track.style.animation = 'none';
            return;
          }
          var containerW = ticker.clientWidth;
          var base = Array.prototype.slice.call(track.children);
          // Widen one "half" until it comfortably exceeds the viewport (no blank gap).
          var guard = 0;
          while (track.scrollWidth < containerW && guard < 60) {
            base.forEach(function (n) { track.appendChild(cloneItem(n)); });
            guard++;
          }
          // Duplicate the half so translateX(-50%) is a seamless wrap.
          var half = Array.prototype.slice.call(track.children);
          half.forEach(function (n) { track.appendChild(cloneItem(n)); });
          // Keep the scroll speed constant (~70px/s) regardless of item count.
          var halfWidth = track.scrollWidth / 2;
          track.style.animationDuration = Math.max(12, Math.round(halfWidth / 70)) + 's';
        };
        setupTicker();
        if (window.ResizeObserver) {
          var tickerRO = new ResizeObserver(function () { setupTicker(); });
          tickerRO.observe(ticker);
        }
      }

      // ----- market carousel (only rendered when >6 products) -----
      var market = root.querySelector('[data-harvest-market]');
      if (market) {
        var mPrev = root.querySelector('[data-harvest-market-prev]');
        var mNext = root.querySelector('[data-harvest-market-next]');
        var mPage = function (dir) { market.scrollBy({ left: dir * Math.round(market.clientWidth * 0.9), behavior: 'smooth' }); };
        if (mPrev) mPrev.addEventListener('click', function () { mPage(-1); });
        if (mNext) mNext.addEventListener('click', function () { mPage(1); });
      }

      // ----- matrix rain -----
      var canvas = root.querySelector('.harvest__matrix');
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (canvas && root.dataset.matrix === 'true' && !prefersReduced) {
        var ctx = canvas.getContext('2d');
        var color = root.dataset.matrixColor || '#5a5470';
        var fontSize = 16;
        var columns, drops;
        function resize() {
          canvas.width = root.offsetWidth;
          canvas.height = root.offsetHeight;
          columns = Math.floor(canvas.width / fontSize);
          drops = [];
          for (var i = 0; i < columns; i++) { drops[i] = Math.random() * -50; }
        }
        resize();
        var ro = window.ResizeObserver ? new ResizeObserver(resize) : null;
        if (ro) ro.observe(root); else window.addEventListener('resize', resize);

        function draw() {
          ctx.fillStyle = 'rgba(0,0,0,0.08)';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.fillStyle = color;
          ctx.font = fontSize + 'px monospace';
          for (var i = 0; i < drops.length; i++) {
            var text = String(Math.floor(Math.random() * 10));
            ctx.fillText(text, i * fontSize, drops[i] * fontSize);
            if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) { drops[i] = 0; }
            drops[i]++;
          }
        }
        setInterval(draw, 60);
      }
    }

    function boot() {
      document.querySelectorAll('[data-harvest]').forEach(initHarvest);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    // Re-init when a merchant adds/edits the section in the theme editor.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-harvest]');
      if (root) initHarvest(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
